import React, { useState } from "react";
import withStyles from "@material-ui/styles/withStyles";
import { TextField, InputAdornment, SvgIcon } from "@material-ui/core";

import { styles } from "./SearchBox.styles";

const SearchIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z" />
    </SvgIcon>
  );
};

const ClearIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8ZM12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" />
    </SvgIcon>
  );
};

function SearchBox({ classes, onEnter, fast }) {
  const [query, setQuery] = useState("");

  const onChangeHandler = (e) => {
    setQuery(e.target.value);
    if (fast) {
      onEnter && onEnter(e.target.value);
    }
  };

  const onKeyDownHandler = (e) => {
    if (e.keyCode === 13 && ((query && query.length > 2) || query === "")) {
      onEnter && onEnter(query);
    }
  };

  const onClearHandler = () => {
    setQuery("");
    onEnter && onEnter(null);
  };

  return (
    <div className={classes.root}>
      <TextField
        className={classes.input}
        margin="none"
        variant="outlined"
        size="small"
        value={query}
        onChange={onChangeHandler}
        onKeyDown={onKeyDownHandler}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: query && (
            <InputAdornment position="end">
              <ClearIcon onClick={onClearHandler} className={classes.clear} />
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
}

export default withStyles(styles)(SearchBox);
